(function ($) {
  if (!$ || !$.fn) return;

  var NS = '.a11ySlickFix';
  var observerStarted = false;

  function cleanup(root) {
    if (!root) return;

    var $root = $(root);

    // If the event target is a slide, clean its nearest slider container too
    if ($root.hasClass('slick-slide')) {
      var $slider = $root.closest('.slick-slider, .slick-initialized, .announcement-slider');
      if ($slider.length) $root = $slider;
    }

    $root.find('.slick-slide[aria-describedby]').each(function () {
      var id = this.getAttribute('aria-describedby');
      if (id && !document.getElementById(id)) {
        this.removeAttribute('aria-describedby');
      }
    });
  }

  function sweepAll() {
    $('.slick-initialized, .slick-slider, .announcement-slider').each(function () {
      cleanup(this);
    });
  }

  function bindEvents() {
    // Prevent duplicate bindings if this script is loaded twice
    $(document).off(NS);

    // Slick lifecycle events (fired on slider element)
    $(document).on(
      'init' + NS + ' reInit' + NS + ' setPosition' + NS + ' breakpoint' + NS + ' afterChange' + NS,
      function (e) {
        cleanup(e.target);
      }
    );

    // Shopify theme editor / section & block events
    $(document).on(
      'shopify:section:load' + NS +
      ' shopify:section:select' + NS +
      ' shopify:section:reorder' + NS +
      ' shopify:block:select' + NS +
      ' shopify:block:deselect' + NS,
      function (e) {
        cleanup(e.target);
        // Sometimes the slider initializes a tick later
        setTimeout(function () { cleanup(e.target); }, 50);
        setTimeout(function () { cleanup(e.target); }, 250);
      }
    );

    // Initial sweep + delayed sweeps (covers late init / async images)
    $(function () {
      sweepAll();
      setTimeout(sweepAll, 50);
      setTimeout(sweepAll, 250);
      setTimeout(sweepAll, 1000);
    });
  }

  function startObserver() {
    if (observerStarted || !window.MutationObserver) return;
    observerStarted = true;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        // If new nodes are added, clean within them
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType !== 1) continue;

            // Only act if the added subtree looks slider-related (avoid heavy work)
            if (
              node.classList.contains('slick-slider') ||
              node.classList.contains('slick-initialized') ||
              node.classList.contains('announcement-slider') ||
              node.querySelector && node.querySelector('.slick-slide[aria-describedby]')
            ) {
              cleanup(node);
            }
          }
        }

        // If aria-describedby changes on a slide, re-check it
        if (
          m.type === 'attributes' &&
          m.attributeName === 'aria-describedby' &&
          m.target &&
          m.target.classList &&
          m.target.classList.contains('slick-slide')
        ) {
          cleanup(m.target);
        }
      }
    });

    obs.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-describedby']
    });
  }

  bindEvents();
  startObserver();
})(jQuery);